import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import {computed} from 'vue';

    interface Props {
        loading?: boolean;
        type?: string;
        color?: string;
        width?: string;
        maxWidth?: string;
        height: string;
        borderRadius?: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SkeletonLoader',
  props: {
    loading: { type: Boolean, default: true },
    type: { default: 'rect' },
    color: { default: 'light' },
    width: { default: '100%' },
    maxWidth: { default: 'none' },
    height: {},
    borderRadius: { default: '5px' }
  },
  setup(__props: any) {

    const props = __props;

    const classList = computed(() => [props.type, props.color]);

    const style = computed(() => {
        return {
            borderRadius: props.type === 'circle' ? '50%' : props.borderRadius,
            width: props.width,
            maxWidth: props.maxWidth,
            height: props.height,
        };
    });

return (_ctx: any,_cache: any) => {
  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["skeleton", classList.value]),
        style: _normalizeStyle(style.value)
      }, null, 6))
    : _createCommentVNode("", true)
}
}

})